import styled from "styled-components"

export const OverlayDiv = styled.div`
    display: flex;
    background: hsla(217, 31%, 13%, 0.7);
    width: 100vw;
    height: 100vh;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 1;
`

export const PanelDiv = styled.div`
    align-self: center;
    width: 100%;
    padding-left: 20%;
    padding-right: 20%;
    padding-top: 5%;
    padding-bottom: 5%;
    background: ${({ theme }) => theme.color.background.l};
`



// WEBPACK FOOTER //
// ./src/OctoprintParser/LogOverlay/styles.js